window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
        console.log("BEFORE_LAZY_INIT");
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.search.configs.general.minQueryLength = 1;
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            //     "body main"
            // ];
        }
        else
        {
            window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
                "body main"
            ]
        }
        
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.search.configs.general.minQueryLength = 1;
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            //     "body main"
            // ];
        }
        else
        {
            window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
                "body main"
            ]
        }
        
        return data;
    });
    function closeSort()
    {
        let sort_selector = document.querySelector('.wizzy-common-select-selector');
        if(sort_selector)
        {
            sort_selector.click();
        }
    }
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        let sort_close = document.querySelector('.wz-sort-close');
        if(sort_close)
        {
            sort_close.removeEventListener('click', closeSort);
            sort_close.addEventListener('click', closeSort);
        }

        const total = data?.data?.response?.payload?.total;
        if (total === 1) {
            document.body.classList.add("wizzy-single-result");
        } else {
            document.body.classList.remove("wizzy-single-result");
        }
        
        return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {

        data.minQueryLength = 1;

        const headerSearch = document.querySelector('header-search.header-search');
        if (headerSearch?.hasAttribute('open')) {
            headerSearch.removeAttribute('open');
        }

        return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {

        data.minQueryLength = 1;

        return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
        products.forEach((product) => {
            let attributes = product.attributes;
            if(attributes)
            {
                attributes.forEach((attr) => {
                    if(attr.id === "product_variant_prices")
                    {
                        let first_price = attr.values[0].value[0];
                        let values = attr.values;
                        let same_price = 1;
                        values.forEach((val) => {
                            let cur_val = val.value[0];
                            if(first_price != cur_val)
                            {
                                same_price = 0;
                            }
                        })
                        product.IsSamePrices = same_price;
                    }
                    else if(attr.id === "product_subtitle_tags")
                    {
                        let subtitle_tags = [];
                        let values = attr.values;
                        if (values) {
                            values.forEach((val) => {
                                let text = val.value[0];
                                let checkText = text.toLowerCase();

                                if (
                                    !checkText.includes('color') &&
                                    !checkText.includes('design') &&
                                    !checkText.includes('colour')
                                ) {
                                    subtitle_tags.push(text);
                                }
                            });

                            product.subtitle_tags = subtitle_tags;
                        }
                    }
                    else if(attr.id === "product_value_tags_labels_tags")
                    {
                        let value = attr.values[0].value[0];
                        if(value === "Whats New")
                        {
                            product.new_in = true;
                        }
                        else if(value == "Bestseller")
                        {
                            product.best_seller = true;
                        }
                        else if(value == "Trending")
                        {
                            product.trending = true;
                        }
                    }
                })
            }
            if (product.swatches && product.swatches.length > 0) {
                product.swatches.forEach((swatch) => {

                    if (swatch.key === "colors") {
                    var values = swatch.values;

                    // check if any value doesn't have swatch or type is not visual
                    const invalidSwatch = values.some(v => !v.swatch || v.swatch.type !== "visual");

                    if (invalidSwatch) {
                        product.hasNonVisualSwatch = true;
                    }

                    var isMobile = window.innerWidth < 768;
                    var visibleCount = isMobile ? 3 : 4;

                    product.remainingSwatchCount =
                        values.length > visibleCount ? values.length - visibleCount : 0;

                    swatch.values = values.slice(0, visibleCount);
                    }

                });
            }
        })
        return products;
    });
}


const body = document.body;

function toggleBodyClass() {
   const sidebar = document.querySelector('header-sidebar[open]');

   if (sidebar) {
      body.classList.add('sidebar-open');
   } else {
      body.classList.remove('sidebar-open');
   }
}

// Run initially
toggleBodyClass();

// Observe DOM changes (element added/removed or attribute changed)
const observer = new MutationObserver(toggleBodyClass);

observer.observe(document.body, {
   childList: true, // detect add/remove
   subtree: true, // include all children
   attributes: true, // detect attribute changes
   attributeFilter: ['open']
});